module.exports = __webpack_public_path__ + "media/images/gallery/constellations/cancer/cnc_lines-83af5d31ad2fd556814968efdfda56fa.gif";